import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Shared favorites state + toggle. Guests get an empty set and a login prompt.
export function useFavorites() {
  const { user } = useAuth();
  const qc = useQueryClient();

  const { data: ids = [] } = useQuery({
    queryKey: ["favorite-ids"],
    queryFn: () => apiFetch("/favorites/ids"),
    enabled: !!user,
  });

  const toggle = useMutation({
    mutationFn: (id) => apiFetch(`/listings/${id}/favorite`, { method: "POST" }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["favorite-ids"] });
      qc.invalidateQueries({ queryKey: ["favorites"] });
    },
  });

  return { favoriteIds: ids, toggleFavorite: (id) => toggle.mutate(id) };
}
